import { IPresenterProps } from './types';
import * as S from './styles';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const FooterPresenter = (props: IPresenterProps) => {
    const version = process.env.REACT_APP_VERSION || '0.1.0';
    const gitSha = process.env.REACT_APP_GIT_SHA?.substring(0, 7) || 'dev';
    const buildTime = process.env.REACT_APP_BUILD_TIME || 'local';

    return (
        <S.FooterContainer>
            <S.FooterContent>
                <S.FooterColumn>
                    <S.FooterLogo>MORA</S.FooterLogo>
                    <S.SocialLinks>
                        <S.SocialIcon href="#" target="_blank" rel="noopener noreferrer">
                            <Instagram size={20} />
                        </S.SocialIcon>
                    </S.SocialLinks>
                </S.FooterColumn>

                <S.FooterColumn>
                    <S.FooterTitle>Para clientes</S.FooterTitle>
                    <S.FooterLink to="/search">Buscar servicios</S.FooterLink>
                </S.FooterColumn>

                <S.FooterColumn>
                    <S.FooterTitle>Para negocios</S.FooterTitle>
                    <S.FooterLink to="/businessRegistration">Registra tu negocio</S.FooterLink>
                </S.FooterColumn>

            </S.FooterContent>

            <S.FooterBottom>
                <S.Copyright>&copy; {new Date().getFullYear()} Mora. Todos los derechos reservados.</S.Copyright>
                <S.VersionInfo>
                    v{version} | {gitSha} | {buildTime}
                </S.VersionInfo>
            </S.FooterBottom>
        </S.FooterContainer>
    )
};

export default FooterPresenter;
